import imageCompression from "browser-image-compression";
export async function imageCompressorFunc(imageFile, maxSizeMB = 1, maxWidthOrHeight = 1000) {


    const options = {
        maxSizeMB,
        maxWidthOrHeight,
        useWebWorker: true,
    };
    try {
        const compressedFile = await imageCompression(imageFile, options);
        return {
            ok: true,
            msg: 'Success!!',
            data: compressedFile
        }
    } catch (error) {
        return {
            ok: false,
            msg: 'Error',
            problem: error
        }
    }
}

export function getBase64(file) {
    return new Promise((resolve) => {
        // let fileInfo;
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(file);

        // on reader load somthing...
        reader.onload = () => {
            // Make a fileInfo Object
            baseURL = reader.result;
            resolve(baseURL);
        };
        // console.log(fileInfo);
    });
}